import React from "react"
import { ShiningSquare } from "ui/components/ShiningSquare"

export const LoginPageShiningSquares = () => (
  <>
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "5.4%",
        left: "11.2%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "16.9%",
        left: "85.6%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "85.3%",
        left: "15.1%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "19.7%",
        left: "43.5%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "25.6%",
        left: "92%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "41.2%",
        left: "78.9%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "51.1%",
        left: "29.2%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "60%",
        left: "85.3%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "63.9%",
        left: "94.3%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "68.2%",
        left: "4.4%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "76.6%",
        left: "23.1%"
      }}
    />
    <ShiningSquare
      sx={{
        position: "absolute",
        top: "81%",
        left: "69.2%"
      }}
    />
  </>
)
